// src/App.js
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import FloatingActions from './components/FloatingActions';
import Navbar from './components/Navbar';
import Footer from './components/Footer';

import Home from './pages/home.jsx';
import About from './pages/About.jsx';
import Contact from './pages/Contact.jsx';
import Terms from './pages/TermsOfServices.jsx';
import Privacy from './pages/privacy.jsx';
import SofaPage from './components/product-pages/SofaPage.jsx';
import CoffeeTablePage from './components/product-pages/coffeeTablePage.jsx';
import ProductDetails from './components/product-pages/ProductDetails.jsx';
import LivingRoom from './components/product-pages/livingRoom.jsx';
import ScrollToTop from "./components/product-pages/ScrollToTop.jsx";

function App() {

  useEffect(() => {
    // Disable on mobile
    if (window.innerWidth < 768) return;

    const cursor = document.querySelector(".cursor");
    const ring = document.querySelector(".cursor-ring");

    const moveCursor = (e) => {
      if (!cursor || !ring) return;

      cursor.style.left = e.clientX + "px";
      cursor.style.top = e.clientY + "px";

      ring.style.left = e.clientX + "px";
      ring.style.top = e.clientY + "px";
    };

    window.addEventListener("mousemove", moveCursor);

    // Hover effect
    const handleHover = () => {
      if (ring) {
        ring.style.width = "60px";
        ring.style.height = "60px";
      }
    };

    const handleLeave = () => {
      if (ring) {
        ring.style.width = "36px";
        ring.style.height = "36px";
      }
    };

    const elements = document.querySelectorAll("a, button");

    elements.forEach((el) => {
      el.addEventListener("mouseenter", handleHover);
      el.addEventListener("mouseleave", handleLeave);
    });

    return () => {
      window.removeEventListener("mousemove", moveCursor);
      elements.forEach((el) => {
        el.removeEventListener("mouseenter", handleHover);
        el.removeEventListener("mouseleave", handleLeave);
      });
    };
  }, []);

  return (
    <Router>

      {/* ✅ Custom Cursor (GLOBAL) */}
      <div className="cursor"></div>
      <div className="cursor-ring"></div>

      <ScrollToTop />
      <Navbar />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/sofas" element={<SofaPage />} />
        <Route path="/coffee-tables" element={<CoffeeTablePage />} />
        <Route path="/product/:id" element={<ProductDetails />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/living-room" element={<LivingRoom />} />
      </Routes>

      <FloatingActions />
      <Footer />
    </Router>
  );
}

export default App;